export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.hook("app:mounted", async () => {
    const { preloaderDone, initAOS } = useProjectMethods();
    preloaderDone();
    initAOS();
  });
});
